import React, { Component } from "react";
import { Container, Card, CardHeader, CardBody, Collapse } from "reactstrap";
import { RouterProps, Styled } from "../../../../toolkit/decorators/Artifact";
import { ProcesoAnualidadDispatcher } from "../../../containers/comisionesAnualidad/proceso/Proceso.dispatcher";
import { ProcesoAnualidadStore } from "../../../containers/comisionesAnualidad/proceso/Proceso.store";
import s from "./styles.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckDouble,
  faChevronCircleDown,
  faChevronCircleUp,
  faExclamationTriangle,
  faSpinner,
  faCalculator,
  faChartBar,
  faFileExcel,
  faUndo
} from "@fortawesome/free-solid-svg-icons";
import {
  EstadoProcesoCierre,
  EstadoProcesoLabels,
  mayorQue,
  mayorIgualQue,
  menorQue
} from "../../../../types/EstadoProcesoCierre";
import ConfirmModal from "../../common/confirmModal/confirmModal";
import { successNotification } from "../../../../utils/notifications";
import {
  downloadAlcancesContactCenter,
  downloadPrecalculoContactCenter,
  downloadComisionesContactCenter,
  downloadAlcancesClub,
  downloadPrecalculoClub,
  downloadComisionesClub
} from "../../../actions/comisionAnualidad";
import FormBuilder from "../../../../toolkit/baseForms2/formBuilder/FormBuilder";
import { formConfig, Inputs, Buttons } from "./Proceso.form";

interface Props
  extends ProcesoAnualidadDispatcher,
    ProcesoAnualidadStore,
    RouterProps {}

interface State {
  openStepCC: number | null;
  openStepClub: number | null;
  loading: boolean;
  downloading: boolean;
  periodo: string;
  pollingInterval: any;
  confirmModal: {
    isOpen: boolean;
    title: string;
    message: string;
    action: (() => Promise<void>) | null;
  };
}

@Styled(s)
export default class ProcesoAnualidadComponent extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      openStepCC: null,
      openStepClub: null,
      loading: false,
      downloading: false,
      periodo: "",
      pollingInterval: null,
      confirmModal: {
        isOpen: false,
        title: "",
        message: "",
        action: null
      }
    };
  }

  async componentDidMount() {
    this.startPolling();
  }

  componentWillUnmount() {
    this.stopPolling();
  }

  startPolling = () => {
    if (this.state.pollingInterval) {
      return;
    }

    const interval = setInterval(() => {
      if (this.state.periodo) {
        this.props.getEstadoProceso(this.state.periodo);
      }
    }, 10000);

    this.setState({ pollingInterval: interval });
  };

  stopPolling = () => {
    if (this.state.pollingInterval) {
      clearInterval(this.state.pollingInterval);
      this.setState({ pollingInterval: null });
    }
  };

  loadPeriodoData = async (periodo: string) => {
    const preview = await this.props.getEstadoProceso(periodo);

    if (preview.fulfilled) {
      const estadoProceso = preview.estadoProceso;

      let stepToOpenCC = 1;
      let stepToOpenClub = 1;

      if (estadoProceso) {
        if (estadoProceso.estadoAnualidadContactCenter) {
          switch (estadoProceso.estadoAnualidadContactCenter) {
            case EstadoProcesoCierre.ANUALIDAD_CONTACT_CENTER_DEFINICION_METAS:
            case EstadoProcesoCierre.ANUALIDAD_CONTACT_CENTER_CALCULO_ALCANCES:
              stepToOpenCC = 2;
              break;
            case EstadoProcesoCierre.ANUALIDAD_CONTACT_CENTER_PRECALCULO:
              stepToOpenCC = 3;
              break;
            case EstadoProcesoCierre.ANUALIDAD_CONTACT_CENTER_CALCULO_MENSUAL:
            case EstadoProcesoCierre.PROCESO_COMPLETADO:
              stepToOpenCC = 4;
              break;
            default:
              stepToOpenCC = 1;
              break;
          }
        }

        if (estadoProceso.estadoAnualidadClub) {
          switch (estadoProceso.estadoAnualidadClub) {
            case EstadoProcesoCierre.ANUALIDAD_CLUB_DEFINICION_METAS:
            case EstadoProcesoCierre.ANUALIDAD_CLUB_CALCULO_ALCANCES:
              stepToOpenClub = 2;
              break;
            case EstadoProcesoCierre.ANUALIDAD_CLUB_PRECALCULO:
              stepToOpenClub = 3;
              break;
            case EstadoProcesoCierre.ANUALIDAD_CLUB_CALCULO_MENSUAL:
            case EstadoProcesoCierre.ANUALIDAD_CLUB_CALCULO_SEMESTRAL:
            case EstadoProcesoCierre.PROCESO_COMPLETADO:
              stepToOpenClub = 4;
              break;
            default:
              stepToOpenClub = 1;
              break;
          }
        }
      }

      this.setState({ openStepCC: stepToOpenCC, openStepClub: stepToOpenClub });
    }
  };

  handlePeriodoSubmit = (data: { [key in Inputs]: any }) => {
    const anio = data.anio || new Date().getFullYear();
    const periodo = `${anio}-${data.mes}-01`;
    this.setState({ periodo }, () => {
      this.loadPeriodoData(periodo);
    });
  };

  openConfirmModal = (
    title: string,
    message: string,
    action: () => Promise<void>
  ) => {
    this.setState({
      confirmModal: {
        isOpen: true,
        title,
        message,
        action
      }
    });
  };

  closeConfirmModal = () => {
    this.setState({
      confirmModal: {
        isOpen: false,
        title: "",
        message: "",
        action: null
      }
    });
  };

  handleConfirmAction = async () => {
    const { action } = this.state.confirmModal;
    if (action) {
      await action();
    }
    this.closeConfirmModal();
  };

  componentDidUpdate() {
    const {
      postingCalcularAlcancesCC,
      postingPrecalculoCC,
      postingCalcularComisionesCC,
      postingCalcularAlcancesClub,
      postingPrecalculoClub,
      postingCalcularComisionesClub,
      deletingRevertirAlcancesCC,
      deletingRevertirPrecalculoCC,
      deletingRevertirComisionesCC,
      deletingRevertirAlcancesClub,
      deletingRevertirPrecalculoClub,
      deletingRevertirComisionesClub,
      deletingRevertirComisionesSemestral,
      estadoProceso
    } = this.props;

    const isExecuting =
      estadoProceso &&
      (estadoProceso.contactCenterAlcanceEnEjecucion ||
        estadoProceso.contactCenterPrecalculoEnEjecucion ||
        estadoProceso.contactCenterComisionEnEjecucion ||
        estadoProceso.clubAlcanceEnEjecucion ||
        estadoProceso.clubPrecalculoEnEjecucion ||
        estadoProceso.clubComisionEnEjecucion);

    const isPosting =
      postingCalcularAlcancesCC ||
      postingPrecalculoCC ||
      postingCalcularComisionesCC ||
      postingCalcularAlcancesClub ||
      postingPrecalculoClub ||
      postingCalcularComisionesClub;

    const isDeleting =
      deletingRevertirAlcancesCC ||
      deletingRevertirPrecalculoCC ||
      deletingRevertirComisionesCC ||
      deletingRevertirAlcancesClub ||
      deletingRevertirPrecalculoClub ||
      deletingRevertirComisionesClub ||
      deletingRevertirComisionesSemestral;

    const isLoading = isPosting || isExecuting || isDeleting;

    if (isLoading !== this.state.loading) {
      this.setState({ loading: isLoading });
    }
  }

  formatPeriodo = (periodo: string): string => {
    if (!periodo) {
      return "";
    }

    const meses = [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre"
    ];

    const [year, month] = periodo.split("-");
    const monthIndex = parseInt(month, 10) - 1;

    return `${meses[monthIndex]} ${year}`;
  };

  toggleStepCC = (step: number, ignoreLoading: boolean = false) => {
    if (this.state.loading && !ignoreLoading) {
      return;
    }
    this.setState({
      openStepCC: this.state.openStepCC === step ? null : step
    });
  };

  toggleStepClub = (step: number, ignoreLoading: boolean = false) => {
    if (this.state.loading && !ignoreLoading) {
      return;
    }
    this.setState({
      openStepClub: this.state.openStepClub === step ? null : step
    });
  };

  renderStepHeader = (
    stepNumber: number,
    title: string,
    isCompleted: boolean = false,
    isOpen: boolean = false,
    toggleFn: (step: number) => void
  ) => {
    const { loading } = this.state;

    return (
      <CardHeader
        onClick={() => toggleFn(stepNumber)}
        className={`${s.procesoStepHeader} ${isOpen ? s.active : ""} ${
          isCompleted ? s.completed : ""
        } ${loading ? s.disabled : ""}`}
        style={{
          cursor: loading ? "not-allowed" : "pointer",
          opacity: loading ? 0.6 : 1
        }}
      >
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center">
            <span className={s.stepNumber}>{stepNumber}</span>
            <span className={s.stepTitle}>
              {title} {isCompleted && <>&#10003;</>}
            </span>
          </div>
          <div className="d-flex align-items-center">
            <FontAwesomeIcon
              icon={isOpen ? faChevronCircleUp : faChevronCircleDown}
              color="#6c757d"
            />
          </div>
        </div>
      </CardHeader>
    );
  };

  isActivityAllowedContactCenter = (
    actividad: EstadoProcesoCierre
  ): { allowed: boolean; reason?: string } => {
    const { estadoProceso } = this.props;
    const estadoActual =
      estadoProceso && estadoProceso.estadoAnualidadContactCenter;

    switch (actividad) {
      case EstadoProcesoCierre.ANUALIDAD_CONTACT_CENTER_DEFINICION_METAS: {
        return !!estadoActual &&
          mayorQue(
            estadoActual,
            EstadoProcesoCierre.ANUALIDAD_CONTACT_CENTER_DEFINICION_METAS
          )
          ? {
              allowed: false,
              reason:
                "No puede modificar las metas después de calcular los alcances"
            }
          : { allowed: true };
      }
      case EstadoProcesoCierre.ANUALIDAD_CONTACT_CENTER_CALCULO_ALCANCES: {
        if (
          menorQue(
            estadoActual,
            EstadoProcesoCierre.ANUALIDAD_CONTACT_CENTER_DEFINICION_METAS
          )
        ) {
          return {
            allowed: false,
            reason: "Debe definir las metas antes de calcular los alcances"
          };
        }
        if (
          mayorQue(
            estadoActual,
            EstadoProcesoCierre.ANUALIDAD_CONTACT_CENTER_CALCULO_ALCANCES
          )
        ) {
          return {
            allowed: false,
            reason: "Los alcances ya fueron calculados y el proceso ha avanzado"
          };
        }
        return { allowed: true };
      }
      case EstadoProcesoCierre.ANUALIDAD_CONTACT_CENTER_PRECALCULO: {
        if (
          menorQue(
            estadoActual,
            EstadoProcesoCierre.ANUALIDAD_CONTACT_CENTER_CALCULO_ALCANCES
          )
        ) {
          return {
            allowed: false,
            reason: "Debe calcular los alcances antes del precálculo"
          };
        }
        if (
          mayorQue(
            estadoActual,
            EstadoProcesoCierre.ANUALIDAD_CONTACT_CENTER_PRECALCULO
          )
        ) {
          return {
            allowed: false,
            reason: "El precálculo ya fue completado"
          };
        }
        return { allowed: true };
      }
      case EstadoProcesoCierre.ANUALIDAD_CONTACT_CENTER_CALCULO_MENSUAL: {
        if (
          menorQue(
            estadoActual,
            EstadoProcesoCierre.ANUALIDAD_CONTACT_CENTER_PRECALCULO
          )
        ) {
          return {
            allowed: false,
            reason: "Debe ejecutar el precálculo antes del cálculo mensual"
          };
        }
        if (
          mayorQue(
            estadoActual,
            EstadoProcesoCierre.ANUALIDAD_CONTACT_CENTER_CALCULO_MENSUAL
          )
        ) {
          return {
            allowed: false,
            reason: "El cálculo mensual ya fue completado"
          };
        }
        return { allowed: true };
      }
      default:
        return {
          allowed: false,
          reason:
            "Actividad no permitida para el Proceso de Anualidad Contact Center"
        };
    }
  };

  isActivityAllowedClub = (
    actividad: EstadoProcesoCierre
  ): { allowed: boolean; reason?: string } => {
    const { estadoProceso } = this.props;
    const estadoActual = estadoProceso && estadoProceso.estadoAnualidadClub;

    switch (actividad) {
      case EstadoProcesoCierre.ANUALIDAD_CLUB_DEFINICION_METAS: {
        return mayorQue(
          estadoActual,
          EstadoProcesoCierre.ANUALIDAD_CLUB_DEFINICION_METAS
        )
          ? {
              allowed: false,
              reason:
                "No puede modificar las metas después de calcular los alcances"
            }
          : { allowed: true };
      }
      case EstadoProcesoCierre.ANUALIDAD_CLUB_CALCULO_ALCANCES: {
        if (
          mayorQue(
            estadoActual,
            EstadoProcesoCierre.ANUALIDAD_CLUB_CALCULO_ALCANCES
          )
        ) {
          return {
            allowed: false,
            reason: "Los alcances ya fueron calculados y el proceso ha avanzado"
          };
        }
        return { allowed: true };
      }
      case EstadoProcesoCierre.ANUALIDAD_CLUB_PRECALCULO: {
        if (
          menorQue(
            estadoActual,
            EstadoProcesoCierre.ANUALIDAD_CLUB_CALCULO_ALCANCES
          )
        ) {
          return {
            allowed: false,
            reason: "Debe calcular los alcances antes del precálculo"
          };
        }
        if (
          mayorQue(estadoActual, EstadoProcesoCierre.ANUALIDAD_CLUB_PRECALCULO)
        ) {
          return {
            allowed: false,
            reason: "El precálculo ya fue completado"
          };
        }
        return { allowed: true };
      }
      case EstadoProcesoCierre.ANUALIDAD_CLUB_CALCULO_MENSUAL: {
        if (
          menorQue(estadoActual, EstadoProcesoCierre.ANUALIDAD_CLUB_PRECALCULO)
        ) {
          return {
            allowed: false,
            reason: "Debe ejecutar el precálculo antes del cálculo mensual"
          };
        }
        if (
          mayorQue(
            estadoActual,
            EstadoProcesoCierre.ANUALIDAD_CLUB_CALCULO_MENSUAL
          )
        ) {
          return {
            allowed: false,
            reason: "El cálculo mensual ya fue completado"
          };
        }
        return { allowed: true };
      }
      case EstadoProcesoCierre.ANUALIDAD_CLUB_CALCULO_SEMESTRAL: {
        if (
          menorQue(
            estadoActual,
            EstadoProcesoCierre.ANUALIDAD_CLUB_CALCULO_MENSUAL
          )
        ) {
          return {
            allowed: false,
            reason:
              "Debe completar el cálculo mensual antes del cálculo semestral"
          };
        }
        if (
          mayorQue(
            estadoActual,
            EstadoProcesoCierre.ANUALIDAD_CLUB_CALCULO_SEMESTRAL
          )
        ) {
          return {
            allowed: false,
            reason: "El cálculo semestral ya fue completado"
          };
        }
        return { allowed: true };
      }
      default:
        return {
          allowed: false,
          reason: "Actividad no permitida para el Proceso de Anualidad Club"
        };
    }
  };

  render() {
    const { openStepCC, openStepClub } = this.state;
    const { estadoProceso } = this.props;

    const estadoCC =
      (estadoProceso && estadoProceso.estadoAnualidadContactCenter) ||
      EstadoProcesoCierre.ANUALIDAD_CONTACT_CENTER_DEFINICION_METAS;
    const estadoClub =
      (estadoProceso && estadoProceso.estadoAnualidadClub) ||
      EstadoProcesoCierre.ANUALIDAD_CLUB_DEFINICION_METAS;

    return (
      <Container className={s.procesoAnualidadContainer}>
        <div style={{ margin: "0 15px" }}>
          <FormBuilder<Inputs, Buttons>
            config={formConfig}
            submit={this.handlePeriodoSubmit}
          />
        </div>

        <div hidden={!estadoProceso} className="alert alert-info">
          <strong>Periodo:</strong> {this.formatPeriodo(this.state.periodo)}
          <div className="mt-2">
            <strong>Estado Contact Center:</strong>{" "}
            {EstadoProcesoLabels[estadoCC]}
          </div>
          <div>
            <strong>Estado Clubes:</strong> {EstadoProcesoLabels[estadoClub]}
          </div>
        </div>

        <div hidden={!estadoProceso} className={s.twoColumnLayout}>
          {/* Columna Contact Center */}
          <div>
            <div className={s.columnHeader}>Contact Center</div>
            <div className={s.procesoAccordion}>
              {/* Paso 1 CC: Definición de Metas */}
              <Card className="mb-2">
                {this.renderStepHeader(
                  1,
                  "Definición de Metas",
                  (estadoProceso &&
                    estadoProceso.metasContactCenterConfiguradas) ||
                    false,
                  openStepCC === 1,
                  this.toggleStepCC
                )}
                <Collapse isOpen={openStepCC === 1}>
                  <CardBody>
                    {(() => {
                      const { estadoProceso } = this.props;
                      const validation = this.isActivityAllowedContactCenter(
                        EstadoProcesoCierre.ANUALIDAD_CONTACT_CENTER_DEFINICION_METAS
                      );
                      const estadoContactCenter =
                        estadoProceso &&
                        estadoProceso.estadoAnualidadContactCenter;

                      if (
                        !validation.allowed &&
                        mayorQue(
                          estadoContactCenter,
                          EstadoProcesoCierre.ANUALIDAD_CONTACT_CENTER_DEFINICION_METAS
                        )
                      ) {
                        return (
                          <div className="alert alert-warning">
                            <FontAwesomeIcon
                              icon={faExclamationTriangle}
                              className="mr-2"
                            />
                            {validation.reason}
                          </div>
                        );
                      }

                      return (
                        <div>
                          <p className="mb-3">
                            Configure las metas de venta para Contact Center del
                            periodo.
                          </p>
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={() =>
                              window.open(
                                "/comisiones-anualidad/configuracion-de-plantilla",
                                "_blank"
                              )
                            }
                          >
                            <FontAwesomeIcon
                              icon={faChartBar}
                              className="mr-2"
                            />
                            Configurar Metas
                          </button>
                        </div>
                      );
                    })()}
                  </CardBody>
                </Collapse>
              </Card>

              {/* Paso 2 CC: Cálculo de Alcances */}
              <Card className="mb-2">
                {this.renderStepHeader(
                  2,
                  "Cálculo de Alcances",
                  mayorIgualQue(
                    estadoCC,
                    EstadoProcesoCierre.ANUALIDAD_CONTACT_CENTER_CALCULO_ALCANCES
                  ),
                  openStepCC === 2,
                  this.toggleStepCC
                )}
                <Collapse isOpen={openStepCC === 2}>
                  <CardBody>
                    {(() => {
                      const { estadoProceso } = this.props;
                      const validation = this.isActivityAllowedContactCenter(
                        EstadoProcesoCierre.ANUALIDAD_CONTACT_CENTER_CALCULO_ALCANCES
                      );
                      const estadoContactCenter =
                        estadoProceso &&
                        estadoProceso.estadoAnualidadContactCenter;
                      const isExecuting =
                        estadoProceso &&
                        estadoProceso.contactCenterAlcanceEnEjecucion;

                      if (
                        !validation.allowed &&
                        menorQue(
                          estadoContactCenter,
                          EstadoProcesoCierre.ANUALIDAD_CONTACT_CENTER_CALCULO_ALCANCES
                        )
                      ) {
                        return (
                          <div className="alert alert-warning">
                            <FontAwesomeIcon
                              icon={faExclamationTriangle}
                              className="mr-2"
                            />
                            {validation.reason}
                          </div>
                        );
                      }

                      if (isExecuting) {
                        return (
                          <div className="alert alert-info">
                            <FontAwesomeIcon
                              icon={faSpinner}
                              spin
                              className="mr-2"
                            />
                            Cálculo de alcances en segundo plano...
                          </div>
                        );
                      }

                      const alcancesCompletados = !menorQue(
                        estadoContactCenter,
                        EstadoProcesoCierre.ANUALIDAD_CONTACT_CENTER_CALCULO_ALCANCES
                      );

                      return (
                        <div>
                          {alcancesCompletados && (
                            <>
                              <div className="alert alert-success mb-3">
                                <FontAwesomeIcon
                                  icon={faCheckDouble}
                                  className="mr-2"
                                />
                                El cálculo de alcances ya fue completado
                              </div>
                              {estadoContactCenter ===
                                EstadoProcesoCierre.ANUALIDAD_CONTACT_CENTER_CALCULO_ALCANCES && (
                                <button
                                  type="button"
                                  className="btn btn-danger mr-2 mb-3"
                                  onClick={() => {
                                    this.openConfirmModal(
                                      "Revertir Cálculo de Alcances - Contact Center",
                                      "¿Está seguro de que desea revertir el cálculo de alcances? Esta acción eliminará los datos calculados.",
                                      async () => {
                                        await this.props.deleteRevertirAlcancesContactCenter(
                                          this.state.periodo
                                        );
                                        await this.props.getEstadoProceso(
                                          this.state.periodo
                                        );
                                        successNotification(
                                          "Cálculo de alcances revertido exitosamente"
                                        );
                                      }
                                    );
                                  }}
                                  disabled={this.state.loading}
                                >
                                  <FontAwesomeIcon
                                    icon={faUndo}
                                    className="mr-2"
                                  />
                                  Revertir
                                </button>
                              )}
                            </>
                          )}
                          {!alcancesCompletados && (
                            <>
                              <p className="mb-3">
                                Ejecute el cálculo de porcentajes de alcances
                                para Contact Center.
                              </p>
                              <button
                                type="button"
                                className="btn btn-primary mr-2"
                                onClick={() => {
                                  this.openConfirmModal(
                                    "Calcular Alcances - Contact Center",
                                    "¿Está seguro de que desea calcular los alcances de Contact Center?",
                                    async () => {
                                      await this.props.postCalcularAlcancesContactCenter(
                                        this.state.periodo
                                      );
                                      this.props.getEstadoProceso(
                                        this.state.periodo
                                      );
                                    }
                                  );
                                }}
                                disabled={this.state.loading}
                              >
                                <FontAwesomeIcon
                                  icon={faCalculator}
                                  className="mr-2"
                                />
                                Calcular Alcances
                              </button>
                            </>
                          )}
                          {alcancesCompletados && (
                            <button
                              type="button"
                              className="btn btn-info"
                              onClick={() => {
                                this.setState({ downloading: true });
                                downloadAlcancesContactCenter(
                                  this.state.periodo,
                                  (error: any) => {
                                    this.setState({ downloading: false });
                                    if (!error) {
                                      successNotification(
                                        "Reporte de alcances descargado"
                                      );
                                    }
                                  }
                                );
                              }}
                              disabled={this.state.downloading}
                            >
                              <FontAwesomeIcon
                                icon={faFileExcel}
                                className="mr-2"
                              />
                              Descargar Reporte
                            </button>
                          )}
                        </div>
                      );
                    })()}
                  </CardBody>
                </Collapse>
              </Card>

              {/* Paso 3 CC: Precálculo */}
              <Card className="mb-2">
                {this.renderStepHeader(
                  3,
                  "Precálculo",
                  mayorIgualQue(
                    estadoCC,
                    EstadoProcesoCierre.ANUALIDAD_CONTACT_CENTER_PRECALCULO
                  ),
                  openStepCC === 3,
                  this.toggleStepCC
                )}
                <Collapse isOpen={openStepCC === 3}>
                  <CardBody>
                    {(() => {
                      const { estadoProceso } = this.props;
                      const validation = this.isActivityAllowedContactCenter(
                        EstadoProcesoCierre.ANUALIDAD_CONTACT_CENTER_PRECALCULO
                      );
                      const estadoContactCenter =
                        estadoProceso &&
                        estadoProceso.estadoAnualidadContactCenter;
                      const isExecuting =
                        estadoProceso &&
                        estadoProceso.contactCenterPrecalculoEnEjecucion;

                      if (
                        !validation.allowed &&
                        menorQue(
                          estadoContactCenter,
                          EstadoProcesoCierre.ANUALIDAD_CONTACT_CENTER_PRECALCULO
                        )
                      ) {
                        return (
                          <div className="alert alert-warning">
                            <FontAwesomeIcon
                              icon={faExclamationTriangle}
                              className="mr-2"
                            />
                            {validation.reason}
                          </div>
                        );
                      }

                      if (isExecuting) {
                        return (
                          <div className="alert alert-info">
                            <FontAwesomeIcon
                              icon={faSpinner}
                              spin
                              className="mr-2"
                            />
                            Precálculo en segundo plano...
                          </div>
                        );
                      }

                      const precalculoCompletado = !menorQue(
                        estadoContactCenter,
                        EstadoProcesoCierre.ANUALIDAD_CONTACT_CENTER_PRECALCULO
                      );

                      return (
                        <div>
                          {precalculoCompletado && (
                            <>
                              <div className="alert alert-success mb-3">
                                <FontAwesomeIcon
                                  icon={faCheckDouble}
                                  className="mr-2"
                                />
                                El precálculo ya fue completado
                              </div>
                              {estadoContactCenter ===
                                EstadoProcesoCierre.ANUALIDAD_CONTACT_CENTER_PRECALCULO && (
                                <button
                                  type="button"
                                  className="btn btn-danger mr-2 mb-3"
                                  onClick={() => {
                                    this.openConfirmModal(
                                      "Revertir Precálculo - Contact Center",
                                      "¿Está seguro de que desea revertir el precálculo? Esta acción eliminará los datos del precálculo.",
                                      async () => {
                                        await this.props.deleteRevertirPrecalculoContactCenter(
                                          this.state.periodo
                                        );
                                        await this.props.getEstadoProceso(
                                          this.state.periodo
                                        );
                                        successNotification(
                                          "Precálculo revertido exitosamente"
                                        );
                                      }
                                    );
                                  }}
                                  disabled={this.state.loading}
                                >
                                  <FontAwesomeIcon
                                    icon={faUndo}
                                    className="mr-2"
                                  />
                                  Revertir
                                </button>
                              )}
                            </>
                          )}
                          {!precalculoCompletado && (
                            <>
                              <p className="mb-3">
                                Ejecute el precálculo de reglas de pago para
                                Contact Center.
                              </p>
                              <button
                                type="button"
                                className="btn btn-primary mr-2"
                                onClick={() => {
                                  this.openConfirmModal(
                                    "Precálculo - Contact Center",
                                    "¿Está seguro de que desea ejecutar el precálculo de Contact Center?",
                                    async () => {
                                      await this.props.postPrecalculoContactCenter(
                                        this.state.periodo
                                      );
                                      this.props.getEstadoProceso(
                                        this.state.periodo
                                      );
                                    }
                                  );
                                }}
                                disabled={this.state.loading}
                              >
                                <FontAwesomeIcon
                                  icon={faChartBar}
                                  className="mr-2"
                                />
                                Ejecutar Precálculo
                              </button>
                            </>
                          )}
                          {precalculoCompletado && (
                            <button
                              type="button"
                              className="btn btn-info"
                              onClick={() => {
                                this.setState({ downloading: true });
                                downloadPrecalculoContactCenter(
                                  this.state.periodo,
                                  (error: any) => {
                                    this.setState({ downloading: false });
                                    if (!error) {
                                      successNotification(
                                        "Reporte de precálculo descargado"
                                      );
                                    }
                                  }
                                );
                              }}
                              disabled={this.state.downloading}
                            >
                              <FontAwesomeIcon
                                icon={faFileExcel}
                                className="mr-2"
                              />
                              Descargar Reporte
                            </button>
                          )}
                        </div>
                      );
                    })()}
                  </CardBody>
                </Collapse>
              </Card>

              {/* Paso 4 CC: Cálculo de Comisiones */}
              <Card className="mb-2">
                {this.renderStepHeader(
                  4,
                  "Cálculo de Comisiones",
                  mayorIgualQue(
                    estadoCC,
                    EstadoProcesoCierre.ANUALIDAD_CONTACT_CENTER_CALCULO_MENSUAL
                  ),
                  openStepCC === 4,
                  this.toggleStepCC
                )}
                <Collapse isOpen={openStepCC === 4}>
                  <CardBody>
                    {(() => {
                      const { estadoProceso } = this.props;
                      const validation = this.isActivityAllowedContactCenter(
                        EstadoProcesoCierre.ANUALIDAD_CONTACT_CENTER_CALCULO_MENSUAL
                      );
                      const estadoContactCenter =
                        estadoProceso &&
                        estadoProceso.estadoAnualidadContactCenter;
                      const isExecuting =
                        estadoProceso &&
                        estadoProceso.contactCenterComisionEnEjecucion;

                      if (
                        !validation.allowed &&
                        menorQue(
                          estadoContactCenter,
                          EstadoProcesoCierre.ANUALIDAD_CONTACT_CENTER_CALCULO_MENSUAL
                        )
                      ) {
                        return (
                          <div className="alert alert-warning">
                            <FontAwesomeIcon
                              icon={faExclamationTriangle}
                              className="mr-2"
                            />
                            {validation.reason}
                          </div>
                        );
                      }

                      if (isExecuting) {
                        return (
                          <div className="alert alert-info">
                            <FontAwesomeIcon
                              icon={faSpinner}
                              spin
                              className="mr-2"
                            />
                            Cálculo de comisiones en segundo plano...
                          </div>
                        );
                      }

                      const calculoCompletado = !menorQue(
                        estadoContactCenter,
                        EstadoProcesoCierre.ANUALIDAD_CONTACT_CENTER_CALCULO_MENSUAL
                      );

                      return (
                        <div>
                          {calculoCompletado && (
                            <>
                              <div className="alert alert-success mb-3">
                                <FontAwesomeIcon
                                  icon={faCheckDouble}
                                  className="mr-2"
                                />
                                El cálculo de comisiones ya fue completado
                              </div>
                              {estadoContactCenter ===
                                EstadoProcesoCierre.ANUALIDAD_CONTACT_CENTER_CALCULO_MENSUAL && (
                                <button
                                  type="button"
                                  className="btn btn-danger mr-2 mb-3"
                                  onClick={() => {
                                    this.openConfirmModal(
                                      "Revertir Cálculo de Comisiones - Contact Center",
                                      "¿Está seguro de que desea revertir el cálculo de comisiones? Esta acción eliminará las comisiones generadas.",
                                      async () => {
                                        await this.props.deleteRevertirComisionesContactCenter(
                                          this.state.periodo
                                        );
                                        await this.props.getEstadoProceso(
                                          this.state.periodo
                                        );
                                        successNotification(
                                          "Cálculo de comisiones revertido exitosamente"
                                        );
                                      }
                                    );
                                  }}
                                  disabled={this.state.loading}
                                >
                                  <FontAwesomeIcon
                                    icon={faUndo}
                                    className="mr-2"
                                  />
                                  Revertir
                                </button>
                              )}
                            </>
                          )}
                          {!calculoCompletado && (
                            <>
                              <p className="mb-3">
                                Ejecute el cálculo de comisiones para Contact
                                Center.
                              </p>
                              <button
                                type="button"
                                className="btn btn-primary mr-2"
                                onClick={() => {
                                  this.openConfirmModal(
                                    "Calcular Comisiones - Contact Center",
                                    "¿Está seguro de que desea calcular las comisiones de Contact Center?",
                                    async () => {
                                      await this.props.postCalcularComisionesContactCenter(
                                        this.state.periodo
                                      );
                                      this.props.getEstadoProceso(
                                        this.state.periodo
                                      );
                                    }
                                  );
                                }}
                                disabled={this.state.loading}
                              >
                                <FontAwesomeIcon
                                  icon={faCalculator}
                                  className="mr-2"
                                />
                                Calcular Comisiones
                              </button>
                            </>
                          )}
                          {calculoCompletado && (
                            <button
                              type="button"
                              className="btn btn-info"
                              onClick={() => {
                                this.setState({ downloading: true });
                                downloadComisionesContactCenter(
                                  this.state.periodo,
                                  (error: any) => {
                                    this.setState({ downloading: false });
                                    if (!error) {
                                      successNotification(
                                        "Reporte de comisiones descargado"
                                      );
                                    }
                                  }
                                );
                              }}
                              disabled={this.state.downloading}
                            >
                              <FontAwesomeIcon
                                icon={faFileExcel}
                                className="mr-2"
                              />
                              Descargar Reporte
                            </button>
                          )}
                        </div>
                      );
                    })()}
                  </CardBody>
                </Collapse>
              </Card>
            </div>
          </div>

          {/* Columna Clubes */}
          <div>
            <div className={s.columnHeader}>Clubes</div>
            <div className={s.procesoAccordion}>
              {/* Paso 1 Club: Definición de Metas */}
              <Card className="mb-2">
                {this.renderStepHeader(
                  1,
                  "Definición de Metas",
                  (estadoProceso && estadoProceso.metasClubConfiguradas) ||
                    false,
                  openStepClub === 1,
                  this.toggleStepClub
                )}
                <Collapse isOpen={openStepClub === 1}>
                  <CardBody>
                    {(() => {
                      const { estadoProceso } = this.props;
                      const validation = this.isActivityAllowedClub(
                        EstadoProcesoCierre.ANUALIDAD_CLUB_DEFINICION_METAS
                      );
                      const estadoClubActual =
                        estadoProceso && estadoProceso.estadoAnualidadClub;

                      if (
                        !validation.allowed &&
                        mayorQue(
                          estadoClubActual,
                          EstadoProcesoCierre.ANUALIDAD_CLUB_DEFINICION_METAS
                        )
                      ) {
                        return (
                          <div className="alert alert-warning">
                            <FontAwesomeIcon
                              icon={faExclamationTriangle}
                              className="mr-2"
                            />
                            {validation.reason}
                          </div>
                        );
                      }

                      return (
                        <div>
                          <p className="mb-3">
                            Configure las metas de venta para Clubes del
                            periodo.
                          </p>
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={() =>
                              window.open(
                                "/comisiones-anualidad/configuracion-de-acumulados",
                                "_blank"
                              )
                            }
                          >
                            <FontAwesomeIcon
                              icon={faChartBar}
                              className="mr-2"
                            />
                            Configurar Metas
                          </button>
                        </div>
                      );
                    })()}
                  </CardBody>
                </Collapse>
              </Card>

              {/* Paso 2 Club: Cálculo de Alcances */}
              <Card className="mb-2">
                {this.renderStepHeader(
                  2,
                  "Cálculo de Alcances",
                  mayorIgualQue(
                    estadoClub,
                    EstadoProcesoCierre.ANUALIDAD_CLUB_CALCULO_ALCANCES
                  ),
                  openStepClub === 2,
                  this.toggleStepClub
                )}
                <Collapse isOpen={openStepClub === 2}>
                  <CardBody>
                    {(() => {
                      const { estadoProceso } = this.props;
                      const validation = this.isActivityAllowedClub(
                        EstadoProcesoCierre.ANUALIDAD_CLUB_CALCULO_ALCANCES
                      );
                      const estadoClubActual =
                        estadoProceso && estadoProceso.estadoAnualidadClub;
                      const isExecuting =
                        estadoProceso && estadoProceso.clubAlcanceEnEjecucion;

                      if (
                        !validation.allowed &&
                        menorQue(
                          estadoClubActual,
                          EstadoProcesoCierre.ANUALIDAD_CLUB_CALCULO_ALCANCES
                        )
                      ) {
                        return (
                          <div className="alert alert-warning">
                            <FontAwesomeIcon
                              icon={faExclamationTriangle}
                              className="mr-2"
                            />
                            {validation.reason}
                          </div>
                        );
                      }

                      if (isExecuting) {
                        return (
                          <div className="alert alert-info">
                            <FontAwesomeIcon
                              icon={faSpinner}
                              spin
                              className="mr-2"
                            />
                            Cálculo de alcances en segundo plano...
                          </div>
                        );
                      }

                      const alcancesCompletados = !menorQue(
                        estadoClubActual,
                        EstadoProcesoCierre.ANUALIDAD_CLUB_CALCULO_ALCANCES
                      );

                      return (
                        <div>
                          {alcancesCompletados && (
                            <>
                              <div className="alert alert-success mb-3">
                                <FontAwesomeIcon
                                  icon={faCheckDouble}
                                  className="mr-2"
                                />
                                El cálculo de alcances ya fue completado
                              </div>
                              {estadoClubActual ===
                                EstadoProcesoCierre.ANUALIDAD_CLUB_CALCULO_ALCANCES && (
                                <button
                                  type="button"
                                  className="btn btn-danger mr-2 mb-3"
                                  onClick={() => {
                                    this.openConfirmModal(
                                      "Revertir Cálculo de Alcances - Clubes",
                                      "¿Está seguro de que desea revertir el cálculo de alcances? Esta acción eliminará los datos calculados.",
                                      async () => {
                                        await this.props.deleteRevertirAlcancesClub(
                                          this.state.periodo
                                        );
                                        await this.props.getEstadoProceso(
                                          this.state.periodo
                                        );
                                        successNotification(
                                          "Cálculo de alcances revertido exitosamente"
                                        );
                                      }
                                    );
                                  }}
                                  disabled={this.state.loading}
                                >
                                  <FontAwesomeIcon
                                    icon={faUndo}
                                    className="mr-2"
                                  />
                                  Revertir
                                </button>
                              )}
                            </>
                          )}
                          {!alcancesCompletados && (
                            <>
                              <p className="mb-3">
                                Ejecute el cálculo de porcentajes de alcances
                                para Clubes.
                              </p>
                              <button
                                type="button"
                                className="btn btn-primary mr-2"
                                onClick={() => {
                                  this.openConfirmModal(
                                    "Calcular Alcances - Clubes",
                                    "¿Está seguro de que desea calcular los alcances de Clubes?",
                                    async () => {
                                      await this.props.postCalcularAlcancesClub(
                                        this.state.periodo
                                      );
                                      this.props.getEstadoProceso(
                                        this.state.periodo
                                      );
                                    }
                                  );
                                }}
                                disabled={this.state.loading}
                              >
                                <FontAwesomeIcon
                                  icon={faCalculator}
                                  className="mr-2"
                                />
                                Calcular Alcances
                              </button>
                            </>
                          )}
                          {alcancesCompletados && (
                            <button
                              type="button"
                              className="btn btn-info"
                              onClick={() => {
                                this.setState({ downloading: true });
                                downloadAlcancesClub(
                                  this.state.periodo,
                                  (error: any) => {
                                    this.setState({ downloading: false });
                                    if (!error) {
                                      successNotification(
                                        "Reporte de alcances descargado"
                                      );
                                    }
                                  }
                                );
                              }}
                              disabled={this.state.downloading}
                            >
                              <FontAwesomeIcon
                                icon={faFileExcel}
                                className="mr-2"
                              />
                              Descargar Reporte
                            </button>
                          )}
                        </div>
                      );
                    })()}
                  </CardBody>
                </Collapse>
              </Card>

              {/* Paso 3 Club: Precálculo */}
              <Card className="mb-2">
                {this.renderStepHeader(
                  3,
                  "Precálculo",
                  mayorIgualQue(
                    estadoClub,
                    EstadoProcesoCierre.ANUALIDAD_CLUB_PRECALCULO
                  ),
                  openStepClub === 3,
                  this.toggleStepClub
                )}
                <Collapse isOpen={openStepClub === 3}>
                  <CardBody>
                    {(() => {
                      const { estadoProceso } = this.props;
                      const validation = this.isActivityAllowedClub(
                        EstadoProcesoCierre.ANUALIDAD_CLUB_PRECALCULO
                      );
                      const estadoClubActual =
                        estadoProceso && estadoProceso.estadoAnualidadClub;
                      const isExecuting =
                        estadoProceso &&
                        estadoProceso.clubPrecalculoEnEjecucion;

                      if (
                        !validation.allowed &&
                        menorQue(
                          estadoClubActual,
                          EstadoProcesoCierre.ANUALIDAD_CLUB_PRECALCULO
                        )
                      ) {
                        return (
                          <div className="alert alert-warning">
                            <FontAwesomeIcon
                              icon={faExclamationTriangle}
                              className="mr-2"
                            />
                            {validation.reason}
                          </div>
                        );
                      }

                      if (isExecuting) {
                        return (
                          <div className="alert alert-info">
                            <FontAwesomeIcon
                              icon={faSpinner}
                              spin
                              className="mr-2"
                            />
                            Precálculo en segundo plano...
                          </div>
                        );
                      }

                      const precalculoCompletado = !menorQue(
                        estadoClubActual,
                        EstadoProcesoCierre.ANUALIDAD_CLUB_PRECALCULO
                      );

                      return (
                        <div>
                          {precalculoCompletado && (
                            <>
                              <div className="alert alert-success mb-3">
                                <FontAwesomeIcon
                                  icon={faCheckDouble}
                                  className="mr-2"
                                />
                                El precálculo ya fue completado
                              </div>
                              {estadoClubActual ===
                                EstadoProcesoCierre.ANUALIDAD_CLUB_PRECALCULO && (
                                <button
                                  type="button"
                                  className="btn btn-danger mr-2 mb-3"
                                  onClick={() => {
                                    this.openConfirmModal(
                                      "Revertir Precálculo - Clubes",
                                      "¿Está seguro de que desea revertir el precálculo? Esta acción eliminará los datos del precálculo.",
                                      async () => {
                                        await this.props.deleteRevertirPrecalculoClub(
                                          this.state.periodo
                                        );
                                        await this.props.getEstadoProceso(
                                          this.state.periodo
                                        );
                                        successNotification(
                                          "Precálculo revertido exitosamente"
                                        );
                                      }
                                    );
                                  }}
                                  disabled={this.state.loading}
                                >
                                  <FontAwesomeIcon
                                    icon={faUndo}
                                    className="mr-2"
                                  />
                                  Revertir
                                </button>
                              )}
                            </>
                          )}
                          {!precalculoCompletado && (
                            <>
                              <p className="mb-3">
                                Ejecute el precálculo de reglas de pago para
                                Clubes.
                              </p>
                              <button
                                type="button"
                                className="btn btn-primary mr-2"
                                onClick={() => {
                                  this.openConfirmModal(
                                    "Precálculo - Clubes",
                                    "¿Está seguro de que desea ejecutar el precálculo de Clubes?",
                                    async () => {
                                      await this.props.postPrecalculoClub(
                                        this.state.periodo
                                      );
                                      this.props.getEstadoProceso(
                                        this.state.periodo
                                      );
                                    }
                                  );
                                }}
                                disabled={this.state.loading}
                              >
                                <FontAwesomeIcon
                                  icon={faChartBar}
                                  className="mr-2"
                                />
                                Ejecutar Precálculo
                              </button>
                            </>
                          )}
                          {precalculoCompletado && (
                            <button
                              type="button"
                              className="btn btn-info"
                              onClick={() => {
                                this.setState({ downloading: true });
                                downloadPrecalculoClub(
                                  this.state.periodo,
                                  (error: any) => {
                                    this.setState({ downloading: false });
                                    if (!error) {
                                      successNotification(
                                        "Reporte de precálculo descargado"
                                      );
                                    }
                                  }
                                );
                              }}
                              disabled={this.state.downloading}
                            >
                              <FontAwesomeIcon
                                icon={faFileExcel}
                                className="mr-2"
                              />
                              Descargar Reporte
                            </button>
                          )}
                        </div>
                      );
                    })()}
                  </CardBody>
                </Collapse>
              </Card>

              {/* Paso 4 Club: Cálculo de Comisiones */}
              <Card className="mb-2">
                {this.renderStepHeader(
                  4,
                  "Cálculo de Comisiones",
                  mayorIgualQue(
                    estadoClub,
                    EstadoProcesoCierre.ANUALIDAD_CLUB_CALCULO_MENSUAL
                  ),
                  openStepClub === 4,
                  this.toggleStepClub
                )}
                <Collapse isOpen={openStepClub === 4}>
                  <CardBody>
                    {(() => {
                      const { estadoProceso } = this.props;
                      const validation = this.isActivityAllowedClub(
                        EstadoProcesoCierre.ANUALIDAD_CLUB_CALCULO_MENSUAL
                      );
                      const estadoClubActual =
                        estadoProceso && estadoProceso.estadoAnualidadClub;
                      const isExecuting =
                        estadoProceso && estadoProceso.clubComisionEnEjecucion;

                      if (
                        !validation.allowed &&
                        menorQue(
                          estadoClubActual,
                          EstadoProcesoCierre.ANUALIDAD_CLUB_CALCULO_MENSUAL
                        )
                      ) {
                        return (
                          <div className="alert alert-warning">
                            <FontAwesomeIcon
                              icon={faExclamationTriangle}
                              className="mr-2"
                            />
                            {validation.reason}
                          </div>
                        );
                      }

                      if (isExecuting) {
                        return (
                          <div className="alert alert-info">
                            <FontAwesomeIcon
                              icon={faSpinner}
                              spin
                              className="mr-2"
                            />
                            Cálculo de comisiones en segundo plano...
                          </div>
                        );
                      }

                      const calculoCompletado = !menorQue(
                        estadoClubActual,
                        EstadoProcesoCierre.ANUALIDAD_CLUB_CALCULO_MENSUAL
                      );

                      return (
                        <div>
                          {calculoCompletado && (
                            <>
                              <div className="alert alert-success mb-3">
                                <FontAwesomeIcon
                                  icon={faCheckDouble}
                                  className="mr-2"
                                />
                                El cálculo de comisiones ya fue completado
                              </div>
                              {estadoClubActual ===
                                EstadoProcesoCierre.ANUALIDAD_CLUB_CALCULO_MENSUAL && (
                                <button
                                  type="button"
                                  className="btn btn-danger mr-2 mb-3"
                                  onClick={() => {
                                    this.openConfirmModal(
                                      "Revertir Cálculo de Comisiones - Clubes",
                                      "¿Está seguro de que desea revertir el cálculo de comisiones? Esta acción eliminará las comisiones generadas.",
                                      async () => {
                                        await this.props.deleteRevertirComisionesClub(
                                          this.state.periodo
                                        );
                                        await this.props.getEstadoProceso(
                                          this.state.periodo
                                        );
                                        successNotification(
                                          "Cálculo de comisiones revertido exitosamente"
                                        );
                                      }
                                    );
                                  }}
                                  disabled={this.state.loading}
                                >
                                  <FontAwesomeIcon
                                    icon={faUndo}
                                    className="mr-2"
                                  />
                                  Revertir
                                </button>
                              )}
                              {estadoClubActual ===
                                EstadoProcesoCierre.ANUALIDAD_CLUB_CALCULO_SEMESTRAL && (
                                <button
                                  type="button"
                                  className="btn btn-danger mr-2 mb-3"
                                  onClick={() => {
                                    this.openConfirmModal(
                                      "Revertir Cálculo de Comisiones Semestrales - Clubes",
                                      "¿Está seguro de que desea revertir el cálculo de comisiones semestrales? Esta acción eliminará las comisiones semestrales generadas.",
                                      async () => {
                                        await this.props.deleteRevertirComisionesSemestral(
                                          this.state.periodo
                                        );
                                        await this.props.getEstadoProceso(
                                          this.state.periodo
                                        );
                                        successNotification(
                                          "Cálculo de comisiones semestrales revertido exitosamente"
                                        );
                                      }
                                    );
                                  }}
                                  disabled={this.state.loading}
                                >
                                  <FontAwesomeIcon
                                    icon={faUndo}
                                    className="mr-2"
                                  />
                                  Revertir Semestral
                                </button>
                              )}
                            </>
                          )}
                          {!calculoCompletado && (
                            <>
                              <p className="mb-3">
                                Ejecute el cálculo de comisiones para Clubes.
                              </p>
                              <button
                                type="button"
                                className="btn btn-primary mr-2"
                                onClick={() => {
                                  this.openConfirmModal(
                                    "Calcular Comisiones - Clubes",
                                    "¿Está seguro de que desea calcular las comisiones de Clubes?",
                                    async () => {
                                      await this.props.postCalcularComisionesClub(
                                        this.state.periodo
                                      );
                                      this.props.getEstadoProceso(
                                        this.state.periodo
                                      );
                                    }
                                  );
                                }}
                                disabled={this.state.loading}
                              >
                                <FontAwesomeIcon
                                  icon={faCalculator}
                                  className="mr-2"
                                />
                                Calcular Comisiones
                              </button>
                            </>
                          )}
                          {calculoCompletado && (
                            <button
                              type="button"
                              className="btn btn-info"
                              onClick={() => {
                                this.setState({ downloading: true });
                                downloadComisionesClub(
                                  this.state.periodo,
                                  (error: any) => {
                                    this.setState({ downloading: false });
                                    if (!error) {
                                      successNotification(
                                        "Reporte de comisiones descargado"
                                      );
                                    }
                                  }
                                );
                              }}
                              disabled={this.state.downloading}
                            >
                              <FontAwesomeIcon
                                icon={faFileExcel}
                                className="mr-2"
                              />
                              Descargar Reporte
                            </button>
                          )}
                        </div>
                      );
                    })()}
                  </CardBody>
                </Collapse>
              </Card>
            </div>
          </div>
        </div>

        <ConfirmModal
          isOpen={this.state.confirmModal.isOpen}
          title={this.state.confirmModal.title}
          message={this.state.confirmModal.message}
          size="md"
          currentValue={null}
          okTitle="Confirmar"
          cancelTitle="Cancelar"
          ok={this.handleConfirmAction}
          cancel={this.closeConfirmModal}
        />
      </Container>
    );
  }
}
